/* eslint-disable import/no-named-as-default-member */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Segment, Grid, Header } from 'semantic-ui-react'
import PartnerActions from '../../reducers/partnerReducer'
import PartnerForm from '../../components/partners/form'

class EditPartner extends Component {
  componentDidMount() {
    const { partners, loaded, fetchPartners, fetchPartner, match } = this.props
    const { id } = match.params

    if (!partners[id]) {
      fetchPartner(id)
    }

    if (!loaded) {
      fetchPartners()
    }
  }

  render() {
    const { match, partners } = this.props
    const partner = partners[match.params.id]

    return (
      <div>
        <Grid>
          <Grid.Column width="16">
            <Segment color="black">
              <Header size="large"> Edit Partner </Header>
              <PartnerForm record={partner} firebaseKey={match.params.id} action="Edit" />
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  partners: state.partners.data,
  loaded: state.partners.loaded,
})

const mapDispatchToProps = dispatch => ({
  dispatch,
  fetchPartners: () => dispatch(PartnerActions.fetchPartnersRequest()),
  fetchPartner: id => dispatch(PartnerActions.fetchPartnerRequest(id)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditPartner)



// WEBPACK FOOTER //
// ./src/containers/partners/edit.js